import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';


class Settings extends React.Component {
	constructor(props) {
		super(props);
		
	}

	componentWillMount() {
	
	}

	render() {
		
		return (

				this.props.children
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;


// WEBPACK FOOTER //
// ./containers/settings/Settings.js